export enum PackageOptions {
  free = 'free_service',
  paid = 'paid_service',
  tax_adviser = 'tax_adviser',
}
